function userGroupSearchRules(app) {
    return {
      // オーナーEXID  チェック ・桁数チェック ・型チェック
      ownerExId: [
        {
          max: 20,
          trigger: 'blur',
          message: app.$t('message.common.validation.max', {
            field: app.$t('label.system.account.search.ownerExId'),
            length: 20
          })
        },
        {
          pattern: /^[A-Za-z0-9]+$/,
          trigger: 'blur',
          message: app.$t('message.common.validation.type', {
            field: app.$t('label.system.account.search.ownerExId'),
            type: '半角英数字'
          })
        }
      ],
      // ビルEXID  チェック ・桁数チェック ・型チェック
      buildingExId: [
        {
          max: 20,
          trigger: 'blur',
          message: app.$t('message.common.validation.max', {
            field: app.$t('label.system.account.search.buildingExId'),
            length: 20
          })
        },
        {
          pattern: /^[A-Za-z0-9]+$/,
          trigger: 'blur',
          message: app.$t('message.common.validation.type', {
            field: app.$t('label.system.account.search.buildingExId'),
            type: '半角英数字'
          })
        }
      ],
      // ユーザー名  チェック ・桁数チェック ・型チェック
      fullname: [
        {
          max: 50,
          trigger: 'blur',
          message: app.$t('message.common.validation.max', {
            field: app.$t('label.system.userGroup.search.userGroupName'),
            length: 50
          })
        }
      ],
      // メールアドレス  チェック ・桁数チェック ・型チェック
      email: [
        {
          max: 319,
          trigger: 'blur',
          message: app.$t('message.common.validation.max', {
            field: app.$t('label.system.account.search.email'),
            length: 319
          })
        },
        {
          pattern: /^[!#$%'*+\-0-9=?A-Z^_`a-z{}~]+(\.[!#$%'*+\-0-9=?A-Z^_`a-z{}~]+)*@(?![\d]+(\.[\d]+)*$)[!#$%'*0-9=?A-Z^`a-z{}~]+([!#$%'*\-0-9=?A-Z^_`a-z{}~]*[!#$%'*0-9=?A-Z^`a-z{}~]+)*(\.[!#$%'*0-9=?A-Z^`a-z{}~]+([!#$%'*\-0-9=?A-Z^_`a-z{}~]*[!#$%'*0-9=?A-Z^`a-z{}~]+)*)+$/,
          trigger: 'blur',
          message: app.$t('message.common.validation.emailType')
        }
      ],
    }
  }

  export default {
    userGroupSearchRules: userGroupSearchRules
  }
